<div class="special-instructions-container" id="item-editor-special-instructions" *transloco="let t">
  @if (instructionHelpText()) {
    <span class="instruction-help-text">{{instructionHelpText()}}</span>
  }
  <cwo-expandable-component [showAlwaysHeader]="showAlwaysExpandButton()" (isExpanded)="handleExpansion($event)" [hideOnExpand]="expanded || needsOrderInstructions()" [headerStyle]="'left'"
    [ariaLabel]="ariaLabel()"
    [ariaControlsName]="'ClickMe'">
    <ng-template #heading>
    @if(!needsOrderInstructions()){
      <cwo-text-button [color]="labelColor()" [tag]="'span'" [focusable]="false" [iconName]="expanded ? iconName.minus : iconName.plus">
        {{ title() }}
      </cwo-text-button>
    }
    </ng-template>
    <ng-template #content>
      <div class="content-wrapper" id="item-editor-special-instructions-content" [attr.aria-hidden]="!expanded" [attr.tabindex]="expanded ? null : -1">
        <div class="label-textarea-count-container">
          <label
            [id]="labelId"
            class="instructions-label"
            [ngClass]="{'invalid': hasError && needsOrderInstructions(), 'required': needsOrderInstructions(), 'sr-only': !descriptionPlaceholder()}"
            [for]="textareaId"
          >
            {{ descriptionPlaceholder() || title() || 'Special Instructions' }}
          </label>
          <textarea 
            class="special-instructions-textarea"
            [ngClass]="{'invalid': hasError && needsOrderInstructions()}"
            [ngStyle]="{'border': removeBorder() ? 'none' : null}"
            [id]="textareaId"
            [attr.maxlength]="maxLength()"
            [(ngModel)]="text"
            (ngModelChange)="onModelChange($event)" (blur)="onBlur()" [attr.aria-labelledby]="labelId" [attr.tabindex]="expanded ? null : -1"
            [disabled]="!expanded && !needsOrderInstructions()">
          </textarea>
          <span
            class="instructions-count"
            id="instructions-count"
            [attr.aria-live]="'polite'"
            [attr.aria-atomic]="'true'"
            [ngClass]="{'invalid': hasError && needsOrderInstructions()}"
            [ngStyle]="{'border': removeBorder() ? 'none' : null, 'bottom': removeBorder() ? '-0.938rem' : null}"
          >
            <span aria-hidden="true">{{ characterCount }} / {{ maxLength() }}</span>
            <span class="sr-only">{{ characterCount }} {{t("route.checkout.checkout_payment_details.validations.charNum")}} {{ maxLength() }}</span>
          </span>
        </div>
        <div [ngClass]="{'error-length-wrapper': hasError && needsOrderInstructions()}">
          @if(hasError && needsOrderInstructions()) {
            <span class="invalid-text-color textarea-error">
              <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{t("route.checkout.checkout_payment_details.validations.instructions_required")}}
            </span>
          }
        </div>
      </div>
    </ng-template>
  </cwo-expandable-component>
</div>